import React from 'react';
import { useTranslation } from 'react-i18next';

import { Center } from '../../styles/center';
import { FullPageBox } from '../full-page-box/full-page-box';

export const RedirectFullPageBox = () => {
  const { t } = useTranslation();

  return (
    <FullPageBox width="400px">
      <Center>
        <label>{t('oneMoment', { ns: 'common' })}</label>
      </Center>
    </FullPageBox>
  );
};
